/**
 * ONE WAY TO HAND THE CHAT A QUESTION FROM ELSEWHERE ON THE PAGE (owner 11-01: "clicking on ask the agent should open the
 * agent with the text filled").
 *
 * The shop's search sheet ends a short or empty list with "Ask the assistant «…»"; the chat (AgentChat) is mounted once
 * beside the routes, so the two do not share state — the same reason the cart drawer listens for `stylon:open-cart`. The
 * chat puts `text` in its composer and opens; it does NOT send: the shopper reads it, may change it, and sends it.
 */
export const OPEN_AGENT_EVENT = 'stylon:open-agent';

export function openAgent(text = '') {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_AGENT_EVENT, { detail: { text: String(text ?? '') } }));
}

export default openAgent;
